(() => {
  const carousels = new WeakSet();
  function initCarousels(root = document) {
    root.querySelectorAll('[data-hero-carousel]').forEach(carousel => {
      if (carousels.has(carousel)) return;
      carousels.add(carousel);
      const slides = Array.from(carousel.querySelectorAll('[data-hero-slide]'));
      if (slides.length < 2) return;
      const controls = carousel.querySelector('[data-hero-controls]');
      controls.hidden = false;
      const pause = carousel.querySelector('[data-hero-pause]');
      const motion = window.matchMedia('(prefers-reduced-motion: reduce)');
      let current = 0, timer, paused = motion.matches, focused = false, hovered = false;
      const warm = () => { if (navigator.connection?.saveData || /(^|-)2g$/.test(navigator.connection?.effectiveType || '')) return; const image = slides[(current + 1) % slides.length].querySelector('img'); if (image) image.loading = 'eager'; };
      function schedule() {
        clearInterval(timer);
        pause.textContent = paused ? pause.dataset.play : pause.dataset.pause;
        if (!paused && !focused && !hovered && !document.hidden && carousel.isConnected) timer = setInterval(() => show(current + 1), 10000);
      }
      function show(index) {
        current = (index + slides.length) % slides.length;
        slides.forEach((slide, i) => { slide.hidden = i !== current; });
        carousel.querySelector('[data-hero-count]').textContent = `${current + 1} / ${slides.length}`;
        warm();
      }
      carousel.querySelector('[data-hero-prev]').addEventListener('click', () => { show(current - 1); schedule(); });
      carousel.querySelector('[data-hero-next]').addEventListener('click', () => { show(current + 1); schedule(); });
      pause.addEventListener('click', () => { paused = !paused; schedule(); });
      carousel.addEventListener('mouseenter', () => { hovered = true; schedule(); });
      carousel.addEventListener('mouseleave', () => { hovered = false; schedule(); });
      carousel.addEventListener('focusin', () => { focused = true; schedule(); });
      carousel.addEventListener('focusout', event => { focused = carousel.contains(event.relatedTarget); schedule(); });
      document.addEventListener('visibilitychange', schedule);
      motion.addEventListener('change', () => { paused = motion.matches; schedule(); });
      document.addEventListener('shopify:section:unload', event => { if (event.target.contains(carousel)) clearInterval(timer); });
      setTimeout(warm, 3000);
      schedule();
    });
  }
  initCarousels();
  document.addEventListener('shopify:section:load', event => initCarousels(event.target));
  const signup = document.querySelector('[data-ridge-signup]');
  if (!signup) return;
  const dialog = signup.querySelector('[data-signup-dialog]');
  const trigger = signup.querySelector('[data-signup-open]');
  const success = dialog.querySelector('[data-signup-success]');
  const errors = dialog.querySelector('[data-signup-errors]');
  let saved = false;
  let dismissed = false;
  try { dismissed = sessionStorage.getItem('ridge-welcome-dismissed') === '1'; } catch {}
  try { saved = !!localStorage.getItem('ridge-welcome-subscribed'); } catch {}
  function syncViewport() {
    const viewport = window.visualViewport;
    dialog.style.setProperty('--ridge-popup-viewport', `${viewport?.height || window.innerHeight}px`);
    dialog.style.setProperty('--ridge-popup-top', `${viewport?.offsetTop || 0}px`);
    dialog.toggleAttribute('data-compact', (viewport?.height || window.innerHeight) < 600);
  }
  let viewportFrame = 0;
  function queueViewport() {
    if (!dialog.open || viewportFrame) return;
    viewportFrame = requestAnimationFrame(() => { viewportFrame = 0; if (dialog.open) syncViewport(); });
  }
  window.visualViewport?.addEventListener('resize', queueViewport, { passive: true });
  window.visualViewport?.addEventListener('scroll', queueViewport, { passive: true });
  window.addEventListener('resize', queueViewport, { passive: true });
  function open() { if (!dialog.open) { syncViewport(); dialog.showModal(); } }
  function dismiss() { dialog.close(); try { sessionStorage.setItem('ridge-welcome-dismissed', '1'); } catch {} }
  trigger.addEventListener('click', open);
  signup.querySelector('[data-signup-close]').addEventListener('click', dismiss);
  dialog.addEventListener('cancel', event => { event.preventDefault(); dismiss(); });
  dialog.addEventListener('click', event => { const box = dialog.getBoundingClientRect(); if (event.target === dialog && (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom)) dismiss(); });
  if (success) { try { localStorage.setItem('ridge-welcome-subscribed', '1'); } catch {} trigger.hidden = true; open(); }
  else if (errors) open();
  else if (saved) trigger.hidden = true;
  else if (!dismissed && !window.Shopify?.designMode) {
    if (!document.hidden) open();
    else document.addEventListener('visibilitychange', () => { if (!document.hidden) open(); }, { once: true });
  }
})();
(() => {
  document.querySelectorAll('.site-header').forEach(header => {
    const groups = Array.from(header.querySelectorAll('.desktop-nav > details, .mobile-nav nav > details'));
    groups.forEach(group => group.addEventListener('toggle', () => {
      if (group.open) groups.forEach(other => { if (other !== group) other.open = false; });
    }));
    header.addEventListener('keydown', event => {
      if (event.key !== 'Escape') return;
      const group = event.target.closest('details[open]');
      if (!group) return;
      group.open = false;
      group.querySelector('summary').focus();
      event.preventDefault();
    });
    document.addEventListener('click', event => {
      if (!header.contains(event.target)) {
        groups.forEach(group => { group.open = false; });
        const mobile = header.querySelector('.mobile-nav');
        if (mobile) mobile.open = false;
      }
    });
  });
})();


(() => {
  const header = document.querySelector('.site-header');
  if (!header) return;
  const desktop = header.querySelector('.desktop-nav');
  const mobile = header.querySelector('.mobile-nav');
  const wide = window.matchMedia('(min-width: 1001px)');
  wide.addEventListener('change', () => {
    const hiddenMenu = wide.matches ? mobile : desktop;
    const hadFocus = hiddenMenu?.contains(document.activeElement);
    if (mobile) mobile.open = false;
    header.querySelectorAll('.desktop-nav > details, .mobile-nav nav > details').forEach(group => { group.open = false; });
    if (hadFocus) (wide.matches ? desktop?.querySelector('summary, a') : mobile?.querySelector('summary'))?.focus();
  });
})();

(() => {
  document.querySelectorAll('.ridge-shop-menu, .ridge-nav-group').forEach(group => {
    group.addEventListener('toggle', () => {
      if (!group.open) {
        group.querySelectorAll('details').forEach(child => { child.open = false; });
        return;
      }
      Array.from(group.parentElement.children).forEach(sibling => {
        if (sibling !== group && sibling.matches('details.ridge-nav-group')) sibling.open = false;
      });
    });
  });
})();

